import { render, staticRenderFns } from "./NewPixPayment.vue?vue&type=template&id=4550a39a"
import script from "./NewPixPayment.vue?vue&type=script&lang=js"
export * from "./NewPixPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports